import React from 'react';
import { intl } from 'ehs-react';
import type { at } from '../../generated/Beans';
type Institution = at.sense.portlets.saf.virtualvisitpatient.model.Institution;

export function InstitutionHeader(props: {
  institution?: Institution;
}): JSX.Element {
  if (props.institution) {
    return (
      <div className="vvpp-institution-header">
        {props.institution?.logo && (
          <img
            className="vvpp-header-institution-icon"
            src={`data:image/jpeg;base64,${props.institution?.logo}`}
            alt="Institution logo"
          />
        )}
        <h2 className="vvpp-institution-logo-header-text">
          {props.institution?.name}
        </h2>
      </div>
    );
  } else {
    return (
      <h2 className="vvpp-institution-logo-header-text">
        {intl('virtualvisitpatientportlet.title')}
      </h2>
    );
  }
}
